<template>
  <el-dialog
    title="新词导入"
    :visible.sync="dialogVisiImport"
    width="50%"
    :close-on-click-modal="false"
    destroy-on-close
    @close="close"
  >
    <div class="container_row" v-loading="diaLoading">
      <span>请选择文件：</span>
      <el-upload
        class="upload-demo-upload"
        :action="sendUrl"
        ref="uploadRef"
        :headers="headers"
        :multiple="false"
        :auto-upload="false"
        :before-upload="beforeUpload"
        :on-error="onError"
        :on-success="handleSuccess"
        accept=".xls,.xlsx,.csv"
        :on-remove="onRemove"
        :on-change="handleChange"
        :file-list="fileList"
      >
        <el-button size="small" type="primary">请选择 Excel 文件</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传.xls/.xlsx/.csv格式文件，且不超过20M
        </div>
      </el-upload>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose(false)" size="small">取 消</el-button>
      <el-button
        type="primary"
        @click="submit"
        size="small"
        :loading="diaLoading"
        >{{ diaLoading ? "导入中" : "导入" }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
// import { importData, getTwoClass, getOneClass, deleteScript } from "@/api/sciptLibrary/index";
import { importDataApi } from "@/api/keyWords/index";
export default {
  props: {
    dialogVisiImport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /** 请求头 */
      headers: {
        authorization: "",
      },
      /** 上传的地址 */
      sendUrl: this.$baseUrl + "/api/qywechat/msg/importData",
      /** 上传的文件列表 */
      fileList: [],
      /** 控制弹窗显示隐藏 */
      diaLoading: false,
      /** 需要加载的请求数量 */
      needLoadingRequestCount: 0,
    };
  },
  methods: {
    // 上传之前
    beforeUpload(file) {
      const nameArr = file.name.split(".");
      const type = nameArr[nameArr.length - 1];
      console.log("beforeUpload", file, type);
      /** 不能超过20mb */
      const isLt2M = file.size / 1024 / 1024 < 20; // 限制大小
      if (["xls", "xlsx", "csv"].indexOf(type) == -1) {
        this.$message.error("上传文件只能是 .xls,.xlsx,.csv 格式!");
        return false;
      }
      /** 超限提示 */
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 20MB!");
        return false;
      }
      /** 显示加载 */
      this.showLoading();
      return true;
    },

    /** 显示加载动画 */
    showLoading() {
      // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
      // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
      if (this.needLoadingRequestCount === 0 && !this.loading) {
        this.loading = this.$loading({
          lock: true,
          text: "拼命上传中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }
      this.needLoadingRequestCount++;
    },

    /** 隐藏加载动画 */
    hideLoading() {
      // if(this.needLoadingRequestCount <= 0) return
      this.needLoadingRequestCount--;
      if (this.needLoadingRequestCount === 0) {
        this.loading.close();
        this.loading = null;
      }
    },

    /** 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用 */
    handleChange(file, fileList) {
      console.log(456, file, fileList);
      this.fileList = [];
      const oneArr = [file];
      this.fileList = oneArr;
    },

    /** 文件上传成功时的钩子  */
    handleSuccess(res, file, fileList) {
      console.log("res", res);
      // if(res.error.code == 200) {
      //   this.type = 0
      //   this.photoList.push(res.data)
      // }else {
      //   this.$message({
      //     message: res.error.message,
      //     type: 'info',
      //     offset: 30,
      //     customClass: 'info-message',
      //     duration: 4000
      //   })
      //   // this.$refs.uploadVideoItem.uploadFiles.splice(this.$refs.uploadVideoItem.uploadFiles.length-1,1)
      // }
      setTimeout(() => {
        this.hideLoading();
      }, 200);
    },

    /** 文件上传失败时的钩子 */
    onError() {
      setTimeout(() => {
        this.hideLoading();
      }, 200);
      this.$message.error("上传失败，请重试！");
    },

    /** 文件列表移除文件时的钩子 触发时候，清空上传列表 */
    onRemove() {
      this.fileList = [];
    },

    /** 提交上传 */
    async submit() {
      /** 判空校验 */
      if (this.fileList.length == 0) {
        return this.$message({
          type: "warning",
          message: "导入文件不能为空",
        });
      }
      /** 开启加载动画 */
      this.diaLoading = true;

      let formData = new FormData();
      this.fileList.forEach((file) => {
        //所有文件保存在formData中
        formData.append("file", file.raw);
      });

      /** 请求导入接口 */
      const res = await importDataApi(
        formData,
        localStorage.getItem("Authorization")
      );

      /** 请求结束关闭加载 */
      this.diaLoading = false;

      // let type = "";
      if (res && res.error && res.error.code == 200) {
        /** 导入结果提示 */
        const tip = `已成功导入${res.data.import || 0}条，<br>
      ${(res.data.repeat && res.data.repeat.join(",")) || ""}${
          res.data.repeat && res.data.repeat.length ? res.data.repeat.length : 0
        }个词存在，无法导入。<br>
       ${(res.data.exception && res.data.exception.join(",")) || ""}${
          res.data.exception && res.data.exception.length
            ? res.data.exception
            : 0
        }个词异常，无法导入。<br>
        ${res.data.limit && res.data.limit.join(",")}${
          res.data.limit && res.data.limit.length ? res.data.limit : 0
        }个超出上限，无法导入。
      `;
        // type = "success";
        /** 导入成功&失败提示 */
        this.$confirm(this.getTip(res.data), "导入结果", {
          confirmButtonText: "我知道了",
          showCancelButton: false,
          type: "warning",
          dangerouslyUseHTMLString: true,
        }).then(() => {
          // if (type == "success") {
          this.handleClose(true);
          // }
          this.fileList = [];
        });
      } else {
        // type = "warning"
        this.$message.error("导入异常，请稍后重试");
        return;
      }
    },

    /** 关闭时触发 */
    handleClose(types = false) {
      // console.log("type234++++",types);
      this.$emit("dialogVisiImport", types);
      // this.$emit("getData");
    },

    /** 关闭弹窗触发 */
    close() {
      this.fileList = [];
      this.$emit("dialogVisiImport", false);
    },

    /** 获取导入结果提示 */
    getTip(data) {
      let tip = [];
      /** 导入成功提示每次必会有，所有直接push进去 */
      tip.push(`已成功导入${data.import || 0}条。<br>`);

      /** 存在导入存在有才需要 */
      if (data.repeat && data.repeat.length) {
        let repeat = data.repeat.join(",")
          ? data.repeat.join(",").length > 20
            ? data.repeat.join(",").slice(0, 20) +"...等"
            : data.repeat.join(",") 
          : "";
        tip.push(
          `${repeat}${
            data.repeat && data.repeat.length ? data.repeat.length : 0
          }个词存在，无法导入。<br>`
        );
      }

      /** 存在有异常的才需要导入 */
      if (data.exception && data.exception.length) {
        let exception = data.exception.join(",")
          ? data.exception.join(",").length > 20
            ? data.exception.join(",").slice(0, 20)+"...等"
            : data.exception.join(",")
          : "";
        tip.push(
          `${exception}${
            data.exception && data.exception.length ? data.exception.length : 0
          }个词异常，无法导入。<br>`
        );
      }

      /** 存在有异常的才需要导入 */
      if (data.limit && data.limit.length) {
        let limit = data.limit.join(",")
          ? data.limit.join(",").length > 20
            ? data.limit.join(",").slice(0, 20)+"...等"
            : data.limit.join(",") + ","
          : "";
        tip.push(
          `${limit}${
            data.limit && data.limit.length ? data.limit.length : 0
          }个超出上限，无法导入。`
        );
      }
      console.log("tip.join('')", tip.join(""));
      return tip.join("") || "数据异常";
    },
    //          const tip = `已成功导入${res.data.import || 0}条，<br>
    //   ${(res.data.repeat && res.data.repeat.join(",")) || ""}${
    //       res.data.repeat && res.data.repeat.length ? res.data.repeat.length : 0
    //     }个词存在，无法导入。<br>
    //    ${(res.data.exception && res.data.exception.join(",")) || ""}${
    //       res.data.exception && res.data.exception.length
    //         ? res.data.exception
    //         : 0
    //     }个词异常，无法导入。<br>
    //     ${res.data.limit && res.data.limit.join(",")}${
    //       res.data.limit && res.data.limit.length ? res.data.limit : 0
    //     }个超出上限，无法导入。
    //   `;
    // }
  },

  /** 生命周期 */
  created() {
    /**  设置上传的请求头部 */
    this.headers.authorization = localStorage.getItem("Authorization");
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-upload-list__item-name) {
  background-color: #409eff !important;
  color: #fff !important;
}
.container_row {
  display: flex;
  justify-content: flex-start;

  // align-items: center;
  span {
    &:not(:first-child) {
      margin-left: 10px;
      cursor: pointer;
    }

    &:nth-child(1) {
    }

    &:nth-child(3) {
      color: #409eff;
      text-decoration: underline;
      margin-left: 150px;
    }
  }

  .upload-demo {
    // padding: 5px 8px;
    // background-color: #409eff;
    // color: #ffff;
    // border-radius: 5px;
    position: relative;

    .el-upload__tip {
      position: absolute !important;
      width: 230%;
      color: red;
    }

    /deep/.el-upload-list {
      margin-top: 35px;
    }
  }
}
.el-upload__tip {
  color: red;
}
/** 限制上传的文件文件名超长，导致的样式变化 */
/deep/.el-upload-list__item-name{
  max-width: 600px
}
</style>
